export enum IAMetricxTags {
  GROUPING_TAG = 'feature',
  EXECUTION_TAG = 'execution-id',
  SOURCE_TAG = 'source',
  CONSULTATION_RECORD_FEATURE = 'consultation-record',
  MOBILE_SOURCE = 'health-professional'
}
